import { AppAccessDenied } from "@/features/access-denied";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/access-denied")({
  component: AppAccessDenied
});
